import { Component, forwardRef, Input, AfterViewInit, ElementRef, ViewChild, ViewContainerRef, OnInit, TemplateRef } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { CommonService } from '@product/shared/services/common.service';
import { MainFilterClass } from '../main-filter';
import { BlockScrollStrategy, Overlay, OverlayRef, ScrollStrategyOptions } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';

@Component({
  selector: 'app-select-filter',
  templateUrl: './select-filter.component.html',
  styleUrls: ['./select-filter.component.less'],
  
})
export class SelectFilterComponent  extends MainFilterClass {
// 

// ngOnInit() {
//   this.value = null;  
//   this.onModelChange.emit(this.value);  
// }

private overlayRef: OverlayRef;
  constructor(public commonService: CommonService,
    
  ) {
    super();
    
  }
  override onChange(value: any) {
    super.onChange(value);
  }

}
